module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgrid),
      expression: "showgrid"
    }]
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "ng-show": "$ctrl.isNewAvaiable()"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona um público alvo",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showgrid = !_vm.showgrid
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova equipe")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "youngs",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
      }
    }, {
      key: "women",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exclui(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }])
  })], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('título do curso')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "título do curso"
    }
  }, [_vm._v("Título do curso:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.title),
      expression: "curso.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "título do curso",
      "type": "text"
    },
    domProps: {
      "value": (_vm.curso.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('título do curso')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('título do curso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('quantidade de educadores')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "quantidade de educadores"
    }
  }, [_vm._v(" Quantidade de educadores: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.educators),
      expression: "curso.educators"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "quantidade de educadores",
      "id": "quantidade de educadores",
      "type": "number"
    },
    domProps: {
      "value": (_vm.curso.educators)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "educators", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('quantidade de educadores')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de educadores')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('carga horaria')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "carga horaria"
    }
  }, [_vm._v("Carga horária semanal:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "career.workload.null",
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.workload),
      expression: "curso.workload"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control text-right ng-pristine ng-scope ng-not-empty ng-valid-max ng-valid-required ng-invalid ng-invalid-min ng-touched",
    attrs: {
      "name": "carga horaria",
      "id": "carga horaria",
      "type": "number"
    },
    domProps: {
      "value": (_vm.curso.workload)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "workload", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Horas")])]), _vm._v(" "), (_vm.errors.first('carga horaria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('carga horaria')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('quantidade de turmas')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "quantidade de turmas"
    }
  }, [_vm._v("Quantidade de turmas:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.classes),
      expression: "curso.classes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "quantidade de turmas",
      "id": "quantidade de turmas",
      "type": "number"
    },
    domProps: {
      "value": (_vm.curso.classes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "classes", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('quantidade de turmas')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de turmas')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('quantidade de alunos por turma')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "quantidade de alunos por turma"
    }
  }, [_vm._v("Quantidade de alunos por turma:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.studentsPerClass),
      expression: "curso.studentsPerClass"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "quantidade de alunos por turma",
      "id": "quantidade de alunos por turma",
      "type": "number"
    },
    domProps: {
      "value": (_vm.curso.studentsPerClass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "studentsPerClass", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('quantidade de alunos por turma')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de alunos por turma')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('público-alvo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "título do curso"
    }
  }, [_vm._v("Público-alvo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.targetAudience),
      expression: "curso.targetAudience"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-scope ng-empty ng-invalid ng-invalid-required ng-touched",
    attrs: {
      "name": "público-alvo",
      "id": "público-alvo",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.curso.targetAudience)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "targetAudience", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('público-alvo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('conteúdo programático mínimo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "conteúdo programático mínimo"
    }
  }, [_vm._v("Conteúdo programático mínimo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.content),
      expression: "curso.content"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-scope ng-empty ng-invalid ng-invalid-required ng-touched",
    attrs: {
      "name": "conteúdo programático mínimo",
      "id": "conteúdo programático mínimo",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.curso.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('conteúdo programático mínimo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('conteúdo programático mínimo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('perfil dos profissionais a serem contratados')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "perfil dos profissionais a serem contratados"
    }
  }, [_vm._v("Perfil dos profissionais a serem contratados:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.professionalProfile),
      expression: "curso.professionalProfile"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-scope ng-empty ng-invalid ng-invalid-required ng-touched",
    attrs: {
      "name": "perfil dos profissionais a serem contratados",
      "id": "perfil dos profissionais a serem contratados",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.curso.professionalProfile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "professionalProfile", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('perfil dos profissionais a serem contratados')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('perfil dos profissionais a serem contratados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('especificação dos serviços')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "especificação dos serviços"
    }
  }, [_vm._v("Especificação dos serviços:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.serviceSpecification),
      expression: "curso.serviceSpecification"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-scope ng-empty ng-invalid ng-invalid-required ng-touched",
    attrs: {
      "name": "especificação dos serviços",
      "id": "especificação dos serviços",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.curso.serviceSpecification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "serviceSpecification", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('especificação dos serviços')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('especificação dos serviços')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-team-add"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-team-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2610308b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/cursosOld.vue
// module id = 1884
// module chunks = 1